/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';

const AllEnquiries = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);

  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('allEnq', () => axios.get('https://orca-app-5i5qx.ondigitalocean.app/api/admin/enquiries/all', {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));
  if (data && !isLoading && !isFetching && !isError) {
    // console.log('all Enquiries', data);
  }

 
  const history = useHistory();
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">All Enquiries</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">All Enquiries Table</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Advance</th>
                    <th>Against Bill</th>
                    {/* <th>Enquiry By</th> */}
                    <th>Loading Expanses</th>
                    <th>Loading Time</th>
                    <th>Material</th>
                    {/* <th>PickUp Address Id</th> */}
                    <th>Remarks</th>
                    <th>Time Stamp</th>
                    {/* <th>To Consignee Id</th> */}
                    <th>Truck Type</th>
                    <th>Unloading Expense </th>
                    <th>Weight</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isError && data && data.data.data && data.data.data && data.data.data.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.advance}</td>
                      <td>{item.againstBill}</td>
                      {/* <td>{item.enquiryBy}</td> */}
                      <td>{item.loadingExpense}</td>
                      <td>{new Date(item.loadingTime).toLocaleDateString()}</td>
                      <td>{item.material}</td>
                      {/* <td>{item.pickupAddresssId}</td> */}
                      <td>{item.remarks}</td>
                      <td>{new Date(item.timestamp).toLocaleDateString()}</td>
                      {/* <td>{item.toConsigneeId}</td> */}
                      <td>{item.truckType}</td>
                      <td>{item.unloadingExpense}</td>
                      <td>{item.weight}</td>
                      {/* <div className="buttons_enq_list">
                        <td><Badge color="primary" onClick={() => history.push(`/all_enquiries/enquiry/${item._id}`)}>View Bids</Badge></td>
                        <td><Badge color="secondary" onClick={() => history.push(`/all_enquiries/enquiry/${item._id}`)}>View Shipments</Badge></td>
                        <td><Badge color="success" onClick={() => history.push(`/all_enquiries/enquiry/${item._id}`)}>more...</Badge></td>
                      </div> */}

                      <UncontrolledDropdown className="adjust_margin-bottom">
                        <DropdownToggle className="icon icon--right" outline>
                          <p>View More... <ChevronDownIcon /></p>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown__menu">
                          <DropdownItem onClick={() => history.push(`/bids/${item._id}`)}>View Bids</DropdownItem>
                          <DropdownItem divider />
                          <DropdownItem onClick={() => history.push(`/shipments/${item._id}`)}>View Shipments</DropdownItem>
                          <DropdownItem divider />
                          <DropdownItem onClick={() => history.push(`/all_enquiries/enquiry/${item._id}`)}>View Enquiries</DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>

                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

AllEnquiries.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(AllEnquiries);
